module.exports = __webpack_public_path__ + "img/tank_factory_small.0b6955e5.png";